import { ServiceApi } from "./Api";
import moment from "moment";
import i18n from "../i18n";

export class HistoricoAceiteLGPD {

    PostHistoricoAceiteLGPD(usuario) {
        let ip = i18n.t("PORTAL.MODAL.LGPD_HISTORY_IP_UNAVAILABLE");
        let local = i18n.t("PORTAL.MODAL.LGPD_HISTORY_LOCATION_UNAVAILABLE");

        localStorage.setItem('AceiteLGPD', 'SIM');

        const ipPromise = ServiceApi.get('https://api.ipify.org')
            .then(resp => {
                ip = resp?.ip || resp?.data?.ip || resp?.data || resp;
            })
            .catch(() => {
                ip = i18n.t("PORTAL.MODAL.LGPD_HISTORY_IP_UNAVAILABLE");
        });

        const localPromise = new Promise((resolve) => {
            if (typeof navigator === 'undefined' || !navigator.geolocation) {
                resolve();
                return;
            }

            navigator.geolocation.getCurrentPosition(
                position => {
                    const coords = position.coords;
                    local = i18n.t("PORTAL.MODAL.LGPD_HISTORY_LOCATION_COORDINATES", {
                        latitude: coords.latitude,
                        longitude: coords.longitude
                    });
                    resolve();
                },
                error => {
                    resolve();
                }
            );
        });

        Promise.all([ipPromise, localPromise]).then(() => {
            const HistoricoLGPD = `${i18n.t("PORTAL.MODAL.LGPD_HISTORY_TITLE")} <br>` +
                `${i18n.t("PORTAL.MODAL.LGPD_HISTORY_USER")}: ${usuario.Nome} <br>` +
                `${i18n.t("PORTAL.MODAL.LGPD_HISTORY_DATE_TIME")}: ${moment(new Date()).format("DD/MM/YYYY HH:mm:ss")} <br>` +
                `IP: ${ip} <br>` +
                `${i18n.t("PORTAL.MODAL.LGPD_HISTORY_LOCATION")}: ${local}`;

            usuario.AcessoDTO.DadosAcesso = HistoricoLGPD;

            ServiceApi.post(`api/Portal/PostAceiteLGPD`, usuario.AcessoDTO)
                .then(resp => {
                    if (resp !== "") {
                        return alert(i18n.t("PORTAL.MODAL.LGPD_CONFIRM_ERROR"));
                    }

                    localStorage.setItem('AceiteLGPD', 'SIM');

                    setTimeout(() => {
                        window.location = "#/portal";
                        window.location.reload();
                    }, 500);
                })
                .catch(error => {
                    console.log(error);
                });
        });
    }


    ChecarAceiteLGPD() {
        const aceiteLGPD = localStorage.getItem('AceiteLGPD') === 'SIM';
        if (aceiteLGPD === false) {
            sessionStorage.clear();
            window.location.reload();
        }
    }

}
